/**
 * Site-wide constants.
 *
 * STREAM_URL is the canonical AzuraCast mountpoint. It is unchanged from v2 and
 * must stay byte-identical to the backend `STREAM_URL` env value — the player
 * binds it directly to <audio src>.
 *
 * API_BASE defaults to same-origin (`/api`) because Apache reverse-proxies the
 * backend in production. Set VITE_BACKEND_URL at build time only if the API
 * lives on another host.
 */

export const STREAM_URL = 'https://stream.deadmoonradio.com/radio/DeadMoonRadio.mp3';

export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_hauntwave-fm/artifacts/hlf8umfg_logo.jpg';

export const TELEGRAM_URL = 'https://t.me/DeadMoonArchives';

export const CONTACT_EMAIL = 'DeadPlayer1@protonmail.com';

export const SITE = {
  name: 'DeadMoon☾Radio',
  version: 'DeadMoonRadio: v3.2',
  tagline: 'Music From the Heavens',
};

const configuredBackend = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/+$/, '');

/** '' means same-origin, which is what production uses. */
export const API_BASE = `${configuredBackend}/api`;

/** How often the player re-reads now-playing metadata. v2 used 15s. */
export const METADATA_POLL_MS = 15000;

/** How often the inbox is polled for Telegram replies. */
export const INBOX_POLL_MS = 4000;

/** How often the Communications Uplink transcript refreshes. */
export const HISTORY_POLL_MS = 12000;

/** How many group messages the uplink transcript shows. */
export const HISTORY_LIMIT = 40;
